import React from 'react';
import './TicketScoreboardPrematch.less';
import moment from 'moment';
import i18n from '@i18n';
import customDateUntilFormat from '@/common/customDateUntilFormating';

function TicketScoreboardPrematch({ bet }) {
    return (
        <div className="ticket-scoreboard-prematch-wrap">
            <div className="ticket-scoreboard-prematch">
                <div className="icon-preview-clock-mini" />
                <div className="match-start-text">
                    {i18n('jsp.detailTiketu.matchStarts')} :{' '}
                    {customDateUntilFormat(moment(), moment(bet.get('expirationDate')))}
                </div>
            </div>
        </div>
    );
}

export default TicketScoreboardPrematch;
